import React from 'react';
import { Panel, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    getSettings,
    updateSettings,
    clearUpdateSettings
} from '../../../actions/settings';
import { Table } from './Table'
import { agents } from '../../../constants/settingTypes';
import EditModal from './EditModal';
import * as permissions from '../../../constants/permissions';

let Agents = class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAddModal: false,
            showUpdateModal: false,
            agentToEdit: null
        }

        this._load = this._load.bind(this);
        this._onAddClick = this._onAddClick.bind(this);
        this._onEditClick = this._onEditClick.bind(this);
        this._onClose = this._onClose.bind(this);
        this._addAgent = this._addAgent.bind(this);
        this._updateAgent = this._updateAgent.bind(this);

    }

    componentDidMount() {
        this._load();
    }

    _load() {
        this.props.getSettings(agents);
    }

    _onAddClick() {
        this.setState({ showAddModal: true });
    }

    _addAgent(agent) {
        this.props.updateSettings(agents, agent);
    }

    _onClose() {
        this.setState({
            showAddModal: false,
            agentToEdit: null,
            showUpdateModal: false
        });
        this.props.clearUpdateSettings(agents);
    }

    _onEditClick(agent) {
        this.setState({ agentToEdit: agent, showUpdateModal: true })
    }

    _updateAgent(agent) {
        this.props.updateSettings(agents, agent, agent.Id);
    }

    render() {
        const { agents: { data, fetching } } = this.props;
        const { showAddModal, showUpdateModal, agentToEdit } = this.state;
        const modalProps = {
            isNew: showAddModal,
            initialValues: agentToEdit ? agentToEdit : { IsActive: true },
            onClose: this._onClose,
            onSubmit: showAddModal ? this._addAgent : this._updateAgent
        };
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        const addByttonClass = `add-glyph${isReadOnly ? '.disabled' : ''}`;
        return (
            <Panel>
                <Panel.Heading >
                    <span>Агенты</span>
                    <Glyphicon
                        glyph='plus'
                        title='Добавить'
                        className={addByttonClass} style={{ float: 'right' }}
                        onClick={isReadOnly ? undefined : this._onAddClick} />
                </Panel.Heading>
                <Panel.Body className='departments-container'>
                    <Table
                        fetching={fetching}
                        agents={data}
                        onEdit={this._onEditClick}
                        isReadOnly={isReadOnly} />
                    {(showAddModal || showUpdateModal) && <EditModal {...modalProps} />}
                </Panel.Body>
            </Panel>
        );
    }
}

Agents = connect(state => {
    /*let settings = state.application.get('settings');
    let agents=  state.application.get('settings')[agents];*/
    return { agents: state.application.get('settings')[agents] };
}, { getSettings, updateSettings, clearUpdateSettings })(Agents);

export default Agents;


// WEBPACK FOOTER //
// ./src/components/settings/agents/Agents.jsx